import React from 'react';
import InvoicingFilter from './InvoicingFilter';
import InvoicingTable from './InvoicingTable';
import useFlatData from '../../../../Base/Hooks/useFlatData';
import useOrders from '../../../Hooks/useOrders';
import { useLazyGetOrdersQuery } from '../../../../../graphql/graphql';
import OverlayLoading from '../../../../../Components/OverlayLoading';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import Loading from '../../../../../Components/Loading';
import InfiniteScroll from 'react-infinite-scroll-component';
// @ts-ignore
import styles from './InvoicingTableWrapper.module.scss';
import { useAppContext } from '../../../../../Services/AppContext';

const WRAPPER_ID = 'invoicingTableWrapper';

interface Props {
	isSuperAdmin?: boolean;
}

const InvoicingTableWrapper: React.FC<Props> = ({ isSuperAdmin }) => {
	const { workplaceId } = useAppContext();
	const [getOrdersQuery, { data, isLoading }] = useLazyGetOrdersQuery();
	const { getOrders, getNextPage, page, setPage } = useOrders(getOrdersQuery);
	const {
		flatData,
		hasMoreData,
		loadData,
		setFilter,
		isLoading: isFlatDataLoading,
	} = useFlatData(
		getOrders,
		{
			data: data?.orders?.data,
			totalPages: data?.orders?.meta?.totalPages,
			page: data?.orders?.meta?.page,
		},
		page,
		setPage,
		{
			workplaceId,
			isAdmin: isSuperAdmin,
		},
	);

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
			<InvoicingFilter onFilter={setFilter} isSuperAdmin={isSuperAdmin} />
			<div className={styles.wrapper}>
				{isFlatDataLoading && <OverlayLoading />}
				<ScrollContainer wrapperId={WRAPPER_ID}>
					<InfiniteScroll
						dataLength={flatData.length}
						refreshFunction={loadData}
						next={getNextPage}
						hasMore={hasMoreData}
						loader={<Loading />}
						scrollableTarget={WRAPPER_ID}>
						<InvoicingTable flatData={flatData} onRefresh={loadData} />
					</InfiniteScroll>
				</ScrollContainer>
			</div>
		</div>
	);
};

export default InvoicingTableWrapper;
